export default "__VITE_ASSET__Bd6_P_SF__"